<template>
  <div class="substep-create-team">
    <div class="substep-header">
      <h3 data-testId="step-title">Create Teams</h3>
      <p>Keep your team organized by creating a team.</p>
    </div>
    <AppButton
      v-if="showTeams"
      class="btn-secondary main-button"
      @click="toggleView"
    >
      Add another team
    </AppButton>
    <div class="substep-body">
      <AppTable
        v-if="showTeams"
        :table-data="teams"
        class="teams-table"
        :loading="showLoading"
      >
        <AppTableColumn
          v-slot="{ row }"
          header="Name"
        >
          <AppAvatarInitial
            size="medium"
            :text="row.name"
          />
          <span>{{ row.name }}</span>
        </AppTableColumn>
      </AppTable>
      <div
        v-else
        class="embedded-form-box"
      >
        <div class="embedded-form-box-body">
          <label class="control-label">TEAM'S NAME</label>
          <AppInput
            v-model="teamName"
            required
            placeholder="New Team Name"
            type="text"
            maxlength="100"
          />
          <span class="errors">
            {{ errorMessage }}
          </span>
        </div>
        <div class="embedded-form-box-footer">
          <AppButton
            class="btn-secondary"
            @click="toggleView"
          >
            Cancel
          </AppButton>
          <AppButton
            :disabled="!teamName"
            :class="['create-team', { 'btn-primary': teamName }]"
            @click="createTeam"
          >
            Confirm
          </AppButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import AppInput from '~/components/AppInput.vue';
import AppTable from '~/components/AppTable.vue';
import AppButton from '~/components/AppButton.vue';
import AppAvatarInitial from '~/components/AppAvatarInitial.vue';
import { TeamsResource } from '~/resources';

export default {
  name: 'CreateTeam',
  components: {
    AppButton,
    AppInput,
    AppTable,
    AppAvatarInitial,
  },
  mixins: [GettingStartedMixin],
  props: {
    organization: {
      type: Object,
      required: true,
      validator: (organization) => {
        return !!organization.id;
      },
    },
    teams: {
      type: Array,
      default: () => [],
      validator: (teams) => {
        return teams.every((team) => {
          return !!team.name;
        });
      },
    },
  },
  data: () => ({
    showTeams: false,
    teamName: '',
    showLoading: false,
    errorMessage: '',
  }),
  watch: {
    teams: {
      immediate: true,
      handler() {
        this.checkTeams();
      },
    },
  },
  mounted() {
    if (this.teams.length > 0) {
      this.showTeams = true;
    }
  },
  methods: {
    toggleView() {
      this.showTeams = !this.showTeams;
    },
    async createTeam() {
      this.errorMessage = '';
      this.showLoading = true;
      const params = {
        team: { name: this.teamName },
      };

      try {
        const response = await TeamsResource.create({ id: this.organization.id }, params, {});

        if (response.success) {
          this.$emit('reloadSubstep');
          this.teamName = '';
          this.toggleView();
        } else {
          this.errorMessage = 'A team with the same name already exists';
        }
      } finally {
        this.showLoading = false;
      }
    },
    checkTeams() {
      if (this.teams.length > 0) {
        this.$emit('completeSubstep');
      }
    },
  },
};
</script>
